import { UniButton } from '@/design-system/components/buttons';
import { Icon } from '@/design-system/components/icons/Icon';
import { H5, H6, TextTitle } from '@/design-system/components/typography';
import { iframePostMessage } from '@/utils/iframePostMessage';
import { Pressable, ScrollView, SxProp, View } from 'dripsy';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Platform, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useStore } from 'store/store';
import { RootStackRoutes } from 'types';
import SVGIconSuccess from '../../../../assets/svg/Success Special.svg';
import { ExchangeSubAccountStackRoutes } from '../../exchange.navigator';
import { useNavigatorPage } from '../../hooks/useNavigatorPage.hook';
import ExchangeImageBackground from '../background/exchange-image-background';
export interface InstructionSubmittedNativeProps {}

export const InstructionSubmittedNativeScreen: React.FC<InstructionSubmittedNativeProps> = () => {
  const insets = useSafeAreaInsets();
  const { t } = useTranslation('exchange-sub-account');
  const store = useStore();
  const navigator = useNavigatorPage();
  const { width, height } = useWindowDimensions();
  const onBackToTrustOverview = () => {
    if (!!store.users?.metadata?.exchangeSubAccount && store.users.metadata.exchangeSubAccount.enabled) {
      iframePostMessage('backToExchangeOverview', true);
    } else {
      iframePostMessage('backToOverview', true);
    }
  };
  return (
    <View sx={{ ...sxStyles.container, ...{ width, height } }}>
      <ExchangeImageBackground />
      <ScrollView sx={sxStyles.safeView} contentContainerStyle={{ flexGrow: 1 }} showsVerticalScrollIndicator={false}>
        {Platform.OS !== 'web' && (
          <View sx={{ ...sxStyles.header, ...{ pt: insets.top + 20 } }}>
            <H6 semiBold sx={sxStyles.textHeader}>
              {t('exchange-account::overview.title--exchange-account')}
            </H6>
            <Pressable onPress={() => navigator.replaceScreen(RootStackRoutes.ExchangeSubAccount, ExchangeSubAccountStackRoutes.Splash)}>
              <Icon color="white" name="closeCircle" width={20} height={20} />
            </Pressable>
          </View>
        )}
        <View sx={sxStyles.body}>
          <View sx={sxStyles.columnView}>
            <View sx={sxStyles.iconView}>
              <SVGIconSuccess height="100%" width="100%" color="#A79378" />
            </View>
            <View sx={sxStyles.centerView}>
              <H5 bold sx={sxStyles.title}>
                {t('exchange-account::applied.title--application-instruction-submitted')}
              </H5>
              <TextTitle semiBold={true} sx={sxStyles.introText}>
                {t('exchange-account::applied.text--get-in-touch-with-you')}
              </TextTitle>
              <TextTitle semiBold={true} sx={sxStyles.introText2}>
                {t('exchange-account::applied.text--customer-service-mobile')}
              </TextTitle>
            </View>
          </View>
        </View>
        <View sx={sxStyles.buttonView}>
          <UniButton label={t('general::back-to-overview')} onPress={() => onBackToTrustOverview()} sx={sxStyles.button} size="medium" />
        </View>
      </ScrollView>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  container: {
    minHeight: 700,
    backgroundColor: '$backgroundPrimary'
  },
  safeView: {
    flex: 1,
    flexDirection: 'column'
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    px: '$4',
    py: '$3'
  },
  textHeader: {
    color: '$textDarkBackground'
  },
  body: {
    pt: '$25',
    flexDirection: 'column',
    flex: 1
  },
  background: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  },
  containerView: {
    borderTopLeftRadius: '$radius2',
    borderTopRightRadius: '$radius2'
  },
  title: {
    color: '#E3B354',
    textAlign: 'center'
  },
  sector: {
    backgroundColor: '$backgroundSecondary',
    height: 5,
    width: '100%'
  },
  introText: {
    mt: '$3',
    textAlign: 'center',
    color: '$textDarkBackground'
  },
  introText2: {
    mt: '$5',
    textAlign: 'center',
    color: '$textDarkBackground'
  },
  columnView: {
    flexDirection: 'column',
    mx: '$4'
  },
  buttonView: {
    position: 'absolute',
    bottom: 50,
    left: 16,
    right: 16
  },
  button: {
    height: 44
  },
  centerView: {
    alignItems: 'center'
  },
  iconView: {
    width: 68,
    height: 68,
    alignSelf: 'center',
    mt: '$4',
    mb: '$5'
  }
};
